export type DesktopPlatform = 'mac' | 'windows';

/** Đúng phần của `navigator` mà phép đoán cần — test truyền vào được mà không phải dựng cả `navigator`. */
export interface PlatformHints {
  readonly userAgent: string;
  readonly maxTouchPoints: number;
  /** User-Agent Client Hints — chỉ Chromium có, và `lib.dom` chưa khai kiểu. */
  readonly userAgentData?: { readonly platform: string; readonly mobile: boolean };
}

/**
 * Đoán máy người xem cần bản cài nào. `null` = không có bản cài cho máy này (điện thoại, iPad,
 * Linux) ⇒ section không gợi ý nút nào.
 *
 * KHÔNG phân biệt được Mac chip Apple với Mac Intel: Safari xưng `Intel Mac OS X` trên CẢ HAI, cố
 * ý để chống lấy dấu vân tay. Đó là lý do section in dòng "Mac Intel chưa được hỗ trợ" cạnh nút,
 * thay vì trông vào phép đoán này.
 */
export function detectPlatform(hints: PlatformHints): DesktopPlatform | null {
  const data = hints.userAgentData;
  if (data !== undefined && data.platform !== '') {
    if (data.mobile) return null;
    if (data.platform === 'macOS') return 'mac';
    if (data.platform === 'Windows') return 'windows';
    return null;
  }

  const ua = hints.userAgent;
  if (/iPhone|iPad|iPod|Android/.test(ua)) return null;
  // iPadOS 13+ xưng `Macintosh` y hệt máy Mac; chỉ cảm ứng đa điểm tách được hai thứ.
  if (/Macintosh|Mac OS X/.test(ua)) return hints.maxTouchPoints > 1 ? null : 'mac';
  if (/Windows/.test(ua)) return 'windows';
  return null;
}
